import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../services/api.service';
import { TypeVehicle } from '../entities/type-vehicle';

/**
 * Base url for api
 */
const BASE_URL = 'type-vehicles';

@Injectable({
  providedIn: 'root',
})

/**
 * Type Vehicle Service
 */
export class TypeVehicleService {
  /**
   * Is loading
   */
  public loading$: Observable<boolean>;

  /**
   * Constructor
   *
   * @param apiService ApiService
   * @param httpClient HttpClient
   * @param authenticationService AuthenticationService
   */
  constructor(private apiService: ApiService) {
    this.loading$ = this.apiService.loading$;
  }

  /**
   * list
   *
   */
  list(): Observable<TypeVehicle[]> {
    return this.apiService
      .get(`${BASE_URL}/list`)
      .pipe(map((typeVehicles) => typeVehicles.map((typeVehicle) => TypeVehicle.createFromJson(typeVehicle))));
  }
}
